import React from "react";
import useProductInfo from "../context/ProductInfoProvider";
import {Button, useNotifications} from "peggirkit";
import DisplayPrice from "@widgets/pos/order/menu/product/cart/DisplayPrice";
import {FormattedMessage, useIntl} from "react-intl";
import {AddToCartProduct} from "@/data/entities/product";
import {addProduct, selectionToAddToCartProduct} from "@/data/entities/cart/utils";
import {useFormContext} from "react-hook-form";
import {PosOrderForm} from "@/data/entities/order";
import {notifySuccess} from "@/utils/NotifyUtils";
import PlusMinusNumberField from "@widgets/input/plusMinusNumberField/PlusMinusNumberField";

const ProductAddToCart = () => {
    const intl = useIntl();
    const {notify} = useNotifications();
    const {
        canAddToBasket,
        product,
        matchingFulfillmentType,
        productSelection,
        setProductSelection,
        setShow,
        loading,
    } = useProductInfo();
    const {getValues, setValue} = useFormContext<PosOrderForm>();
    const addToOrder = () => {
        if (!canAddToBasket)
            return;

        const toAdd: AddToCartProduct = selectionToAddToCartProduct(productSelection);
        setValue(
            "products",
            addProduct(getValues("products"), toAdd),
            {shouldDirty: true, shouldValidate: true},
        );

        setShow(false);
        notifySuccess(intl.formatMessage({id: "addedToCart"}), notify);
    };

    return (
        <footer className={"w-full flex flex-col items-end justify-start gap-3 mt-3"}>
            <PlusMinusNumberField
                label={<FormattedMessage id={"amountToOrder"}/>}
                disabled={!canAddToBasket}
                value={productSelection.count}
                onChange={(newVal: number) => setProductSelection(prev => ({...prev, count: newVal}))}
            />

            <div className={"w-full flex flex-row items-end justify-between gap-2"}>
                <small className={"opacity-70 text-xs"}>
                    <FormattedMessage id={"price-ex-deposit-sup-fee"}/>
                </small>

                <Button
                    loading={loading}
                    disabled={!canAddToBasket}
                    buttonAction={{
                        as: "button",
                        actionProps: {
                            onClick: e => {
                                e.preventDefault();
                                addToOrder();
                            },
                        },
                    }}
                >
                    {
                        product.soldout
                            ? <FormattedMessage id={"soldOut"}/>
                            : (
                                matchingFulfillmentType.match
                                    ? <DisplayPrice/>
                                    : <FormattedMessage id={`unavailable-for-${matchingFulfillmentType.otherType}`}/>
                            )
                    }
                </Button>

            </div>
        </footer>
    );
};

export default ProductAddToCart;